import React from 'react';
import './OnboardingProgressBar.css';

// Preview bar: 9 stages (compact view for grid)
const STAGES = [
  { id: 'form_submitted', name: 'Form', color: '#93c5fd' },
  { id: 'contract_sent', name: 'Form Out', color: '#60a5fa' },
  { id: 'contract_signed', name: 'Form Done', color: '#3b82f6' },
  { id: 'tiktok_outreach', name: 'TikTok', color: '#2563eb' },
  { id: 'snapchat_tips', name: 'Guides', color: '#1d4ed8' },
  { id: 'verified', name: 'Verified', color: '#1e40af' },
  { id: 'monetized', name: 'Monetized', color: '#1e3a8a' },
  { id: 'hyperwallet_setup', name: 'HW Guide', color: '#172554' },
  { id: 'hyperwallet_confirmed', name: 'HW Done', color: '#0c1844' }
];

const OnboardingProgressBar = ({ clientId, statusData, onClick, showWaitingText = true }) => {
  if (!statusData || !statusData.stages) {
    return (
      <div className="onboarding-progress-bar-simple">
        <div className="progress-bar-loading">Loading...</div>
      </div>
    );
  }

  const { stages, current_stage } = statusData;
  
  // Calculate sections
  const completedStages = stages.filter(s => s.completed);
  
  // Find the ACTUAL current stage - first incomplete one
  let actualCurrentStage = stages.findIndex(s => !s.completed);
  if (actualCurrentStage === -1) {
    actualCurrentStage = stages.length; // All complete
  }
  
  const currentStageData = stages[actualCurrentStage];
  
  // Debug log - removed

  const handleClick = () => {
    if (onClick) {
      onClick(clientId);
    }
  };

  // Calculate counts
  const totalStages = stages.length;
  const completedCount = completedStages.length;
  const remainingCount = totalStages - completedCount;

  // Determine what we're waiting on
  let waitingOnText = 'Complete!';
  if (actualCurrentStage < stages.length && currentStageData && !currentStageData.completed) {
    waitingOnText = `Waiting: ${currentStageData.name}`;
  }

  return (
    <div 
      className="onboarding-progress-bar-simple" 
      onClick={handleClick}
      style={{
        justifyContent: showWaitingText ? 'flex-start' : 'center'
      }}
    >
      {/* Multi-colored segmented progress bar */}
      <div className="progress-bar-segments">
        {STAGES.map((stage, index) => {
          const stageData = stages[index];
          const isCompleted = stageData?.completed || false;
          const isLast = index === STAGES.length - 1;
          
          return (
            <div
              key={stage.id}
              className="progress-segment"
              style={{
                backgroundColor: isCompleted ? stage.color : '#f3f4f6',
                opacity: 1,
                width: '20px',
                minWidth: '20px',
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              title={stage.name}
            >
              {isLast && (
                <span className="segment-label-remaining">{remainingCount}</span>
              )}
            </div>
          );
        })}
      </div>

      {/* Status text below bar - conditional */}
      {showWaitingText && (
        <div className="progress-status-text">
          {waitingOnText}
        </div>
      )}
    </div>
  );
};

export default OnboardingProgressBar;
